import createMuiTheme from 'material-ui/styles/createMuiTheme';
import createPalette from 'material-ui/styles/createPalette';
import createTypography from 'material-ui/styles/createTypography';
import { getContrastRatio } from 'material-ui/styles/colorManipulator';

const primaryPalette = {
  50: '#e0f9f3',
  100: '#b3f0e1',
  200: '#80e6ce',
  300: '#4ddbba',
  400: '#26d4ab',
  500: '#00cc9c',
  600: '#00c794',
  700: '#00c08a',
  800: '#00b980',
  900: '#00ad6e',
  A100: '#d7ffee',
  A200: '#a4ffd9',
  A400: '#71ffc4',
  A700: '#58ffb9',
  contrastDefaultColor: 'dark',
};

const secondaryPalette = {
  50: '#e0edf0',
  100: '#b3d1d9',
  200: '#80b2bf',
  300: '#4d93a5',
  400: '#267c92',
  500: '#00657f',
  600: '#005d77',
  700: '#00536c',
  800: '#004962',
  900: '#00374f',
  A100: '#80b2bf',
  A200: '#4d93a5',
  A400: '#00657f',
  A700: '#004962',
  contrastDefaultColor: 'light',
};

const palette = createPalette({
  primary: primaryPalette,
  secondary: secondaryPalette,
  getContrastText: (color) => {
    return getContrastRatio(color, '#000') < 11 ? 'rgba(255, 255, 255, 1)' : 'rgba(0, 0, 0, 0.87)';
  }
});

const fontSize = 14;
const fontFamily = '"Open Sans"';
const fontWeightLight = 300;
const fontWeightRegular = 400;
const fontWeightMedium = 600;

// @todo after all fixes we should use typography from theme
const typography = createTypography(palette, {
  fontSize,
  fontFamily,
  fontWeightLight,
  fontWeightRegular,
  fontWeightMedium,
  // display4: {
  //   fontSize: 112,
  //   fontWeight: fontWeightLight,
  //   fontFamily,
  //   letterSpacing: '-.04em',
  //   lineHeight: 1,
  //   color: palette.text.secondary,
  // },
  // display3: {
  //   fontSize: 56,
  //   fontWeight: fontWeightRegular,
  //   fontFamily,
  //   letterSpacing: '-.02em',
  //   lineHeight: 1.35,
  //   color: palette.text.secondary,
  // },
  display2: {
    fontSize: 42,
    fontWeight: fontWeightLight,
    lineHeight: '50px',
    color: palette.text.primary,
  },
  display1: {
    fontSize: 30,
    fontWeight: fontWeightLight,
    lineHeight: '35px',
    color: palette.text.primary,
  },
  // headline: {
  //   fontSize: 24,
  //   fontWeight: fontWeightRegular,
  //   fontFamily,
  //   lineHeight: '32px',
  //   color: palette.text.primary,
  // },
  title: {
    fontSize: 23,
    fontWeight: fontWeightMedium,
    lineHeight: '28px'
  },
  // subheading: {
  //   fontSize: 16,
  //   fontWeight: fontWeightRegular,
  //   fontFamily,
  //   lineHeight: '24px',
  //   color: palette.text.primary,
  // },
  // body2: {
  //   fontSize: 14,
  //   fontWeight: fontWeightMedium,
  //   fontFamily,
  //   lineHeight: '24px',
  //   color: palette.text.primary,
  // },
  body1: {
    fontSize: 14,
    fontWeight: fontWeightLight,
    lineHeight: '20px'
  },
  // caption: {
  //   fontSize: 12,
  //   fontWeight: fontWeightRegular,
  //   fontFamily,
  //   lineHeight: 1,
  //   color: palette.text.secondary,
  // },
  // button: {
  //   fontSize,
  //   textTransform: 'uppercase',
  //   fontWeight: fontWeightMedium,
  //   fontFamily,
  // },
});

export default () => createMuiTheme({ palette, typography });



// WEBPACK FOOTER //
// ./src/configureTheme.js